<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
  text: string | null | undefined
  position?: 'top' | 'right' | 'bottom' | 'left'
}>()

const tooltipRef = ref<HTMLDivElement | null>(null)
const isVisible = ref(false)
const position = ref({ x: 0, y: 0 })

const updatePosition = (event: MouseEvent) => {
  if (!tooltipRef.value) return

  const offset = 8
  const tooltipWidth = tooltipRef.value.offsetWidth
  const tooltipHeight = tooltipRef.value.offsetHeight

  switch (props.position) {
    case 'right':
      position.value = {
        x: (event.target as HTMLElement).getBoundingClientRect().right + offset,
        y: (event.target as HTMLElement).getBoundingClientRect().top + ((event.target as HTMLElement).getBoundingClientRect().height / 2) - (tooltipHeight / 2)
      }
      break
    default: // top
      position.value = {
        x: (event.target as HTMLElement).getBoundingClientRect().left + ((event.target as HTMLElement).getBoundingClientRect().width / 2) - (tooltipWidth / 2),
        y: (event.target as HTMLElement).getBoundingClientRect().top - tooltipHeight - offset
      }
  }
}

const showTooltip = (event: MouseEvent) => {
  isVisible.value = true
  updatePosition(event)
}

const hideTooltip = () => {
  isVisible.value = false
}
</script>

<template>
  <div class="relative inline-block">
    <div @mouseenter="showTooltip" @mouseleave="hideTooltip">
      <slot />
    </div>
    
    <Teleport to="body">
      <div
        v-if="isVisible"
        ref="tooltipRef"
        class="fixed z-50 px-2 py-1 text-xs font-medium text-white bg-gray-900 dark:bg-gray-700 rounded shadow-sm pointer-events-none transition-opacity duration-200"
        :style="{
          left: `${position.x}px`,
          top: `${position.y}px`
        }"
      >
        {{ text }}
      </div>
    </Teleport>
  </div>
</template>